// Constants
import {
    WORK_TYPE_CREATE_REQUESTED,
    WORK_TYPE_CREATE_SUCCEEDED,
    WORK_TYPE_CREATE_FAILED,
    WORK_TYPE_DELETE_REQUESTED,
    WORK_TYPE_DELETE_SUCCEEDED,
    WORK_TYPE_DELETE_FAILED,
    WORK_TYPES_SET,
    WORK_TYPE_SET
} from './constants';

// Types
import type { WorkType } from './types';

export function requestCreateWorkType(data: Object) {
    return {
        type: WORK_TYPE_CREATE_REQUESTED,
        payload: {
            data
        }
    };
}

export function succeededCreateWorkType(response: Object) {
    return {
        type: WORK_TYPE_CREATE_SUCCEEDED,
        payload: response
    };
}

export function failedCreateWorkType(error: Error) {
    return {
        type: WORK_TYPE_CREATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestDeleteWorkType(id: number) {
    return {
        type: WORK_TYPE_DELETE_REQUESTED,
        payload: {
            id
        }
    };
}

export function succeededDeleteWorkType(response: Object) {
    return {
        type: WORK_TYPE_DELETE_SUCCEEDED,
        payload: response
    };
}

export function failedDeleteWorkType(error: Error) {
    return {
        type: WORK_TYPE_DELETE_FAILED,
        payload: error,
        error: true
    };
}

/**
 * Dispatched when the workTypes are loaded by the scaffoldData request saga
 *
 * @param {Object} data the workTypes data keyed by id
 * @return {object} An action object with a type of WORK_TYPES_SET passing the data as a payload
 */
export function setWorkTypes(data: { [string]: WorkType }) {
    return {
        type: WORK_TYPES_SET,
        payload: data
    };
}

export function setWorkType(data: WorkType) {
    return {
        type: WORK_TYPE_SET,
        payload: data
    };
}
